"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
const FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
const Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex/Flex"));
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const translations_json_1 = __importDefault(require("./translations.json"));
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    container: {
        display: "flex",
        justifyContent: "space-around",
        margin: "0 auto",
        marginTop: theme.spacing.base * 3,
        width: "80%",
        height: "80%",
    },
}), { name: "Error" });
const Error = ({ message }) => {
    const theme = (0, react_jss_1.useTheme)();
    const classes = useStyles({ theme });
    const translations = translations_json_1.default;
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(Flex_1.default, { direction: "row", grow: true },
            react_1.default.createElement(FlatButton_1.default, { primary: true, label: translations["en"]["reload"], onClick: () => void location.reload() }),
            react_1.default.createElement(FlatButton_1.default, { as: "a", href: "/", primary: true, label: translations["en"]["home"] })),
        message ?? translations["en"]["general_error_message"]));
};
exports.default = Error;
